import type { ImgHTMLAttributes } from "react";
import {
  buildUploadSrcSet,
  defaultUploadSrc,
  type ImageFormat,
} from "@/lib/media/image-url";
import { cn } from "@/lib/utils";

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet" | "sizes"> & {
  src: string;
  widths: number[];
  sizes: string;
  format?: ImageFormat;
};

export function ResponsiveImage({
  src,
  widths,
  sizes,
  format = "webp",
  className,
  loading,
  ...rest
}: Props) {
  const isUpload = src.startsWith("/uploads/");

  if (!isUpload) {
    return <img src={src} sizes={sizes} className={cn(className)} loading={loading} {...rest} />;
  }

  const sortedWidths = [...widths].sort((a, b) => a - b);

  return (
    <img
      src={defaultUploadSrc(src, sortedWidths, format)}
      srcSet={buildUploadSrcSet(src, sortedWidths, format)}
      sizes={sizes}
      className={cn(className)}
      loading={loading}
      {...rest}
    />
  );
}
